import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Flame, AlertTriangle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function MainOffer() {
  const {
    t,
    currency,
    language
  } = useLanguage();
  const features = language === 'es' ? ['Diseño profesional personalizado', '100% adaptada a móviles (responsive)', 'Optimización SEO básica incluida', 'Formulario de contacto funcional', 'Integración con WhatsApp', 'Hosting configurado y listo', 'Velocidad de carga optimizada', 'Entrega en menos de 48 horas ⚡', '1 ronda de revisiones incluida'] : ['Custom professional design', '100% mobile responsive', 'Basic SEO optimization included', 'Functional contact form', 'WhatsApp integration', 'Hosting configured and ready', 'Optimized loading speed', 'Delivery in less than 48 hours ⚡', '1 round of revisions included'];
  return <section className="py-16 md:py-24 bg-brand-bg relative" data-id="element-218">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl" data-id="element-219">
        <div className="grid md:grid-cols-5 gap-8 md:gap-12 items-center" data-id="element-220">
          <div className="md:col-span-2 space-y-4 md:space-y-6" data-id="element-221">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-222">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-3 md:mb-4" data-id="element-223">
                {t('offer.title')}{' '}
                <span className="text-brand-cyan" data-id="element-224">{t('offer.title2')}</span>
              </h2>
              <p className="text-gray-400 text-base md:text-lg" data-id="element-225">
                {t('offer.subtitle')}
              </p>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="md:col-span-3 bg-gradient-to-b from-brand-darker to-brand-bg border border-brand-purple/30 rounded-3xl p-6 md:p-10 shadow-[0_0_50px_rgba(139,47,201,0.15)] relative overflow-hidden" data-id="element-226">
            {/* Top highlight bar */}
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-brand-cyan to-brand-purple" data-id="element-227"></div>

            <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6" data-id="element-228">
              <Flame className="w-6 h-6 md:w-8 md:h-8 text-brand-cta" data-id="element-229" />
              <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-white" data-id="element-230">
                {t('offer.heading')}
              </h3>
            </div>

            <div className="mb-6 md:mb-8 pb-6 md:pb-8 border-b border-white/10" data-id="element-231">
              <div className="flex items-baseline gap-3 md:gap-4 mb-2" data-id="element-232">
                <span className="text-4xl md:text-5xl font-bold text-brand-cta" data-id="element-233">
                  {currency}199
                </span>
                <span className="text-lg md:text-xl text-gray-500 line-through" data-id="element-234">
                  {currency}499
                </span>
              </div>
              <p className="text-brand-cyan font-medium text-sm md:text-base" data-id="element-235">
                {t('offer.savings')} {currency}300
              </p>
            </div>

            <ul className="space-y-3 md:space-y-4 mb-8 md:mb-10" data-id="element-236">
              {features.map((feature, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-2 md:gap-3" data-id="element-237">
                  <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-brand-cyan shrink-0" data-id="element-238" />
                  <span className="text-gray-200 text-base md:text-lg" data-id="element-239">
                    {feature}
                  </span>
                </motion.li>)}
            </ul>

            <div className="space-y-3 md:space-y-4" data-id="element-240">
              <a href="https://q5xkzi-4j.myshopify.com/cart/57520197402959:1?channel=buy_button" target="_blank" rel="noopener noreferrer" className="block w-full bg-brand-cta hover:bg-brand-ctaHover text-brand-darker text-center font-bold text-lg md:text-xl py-4 md:py-5 rounded-xl transition-all duration-300 shadow-[0_0_20px_rgba(255,215,0,0.2)] hover:shadow-[0_0_30px_rgba(255,215,0,0.4)] hover:-translate-y-1" data-id="element-241">
                🚀 {t('offer.cta')} {currency}199
              </a>

              <div className="flex items-center justify-center gap-2 text-orange-400 bg-orange-400/10 py-2 rounded-lg text-xs md:text-sm font-medium" data-id="element-242">
                <AlertTriangle className="w-3 h-3 md:w-4 md:h-4" data-id="element-243" />
                <span data-id="element-244">{t('offer.urgency')}</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}